export default "__VITE_ASSET__d$Ab72tP__"